<template>
  <footer id="footer">
    <div class="ft-inner">
      <div class="footer-menu">
        <ul>
          <li>
            <router-link :to="{name: '저작권정책'}" title="새창으로">저작권정책</router-link>
          </li>
        </ul>
      </div>
      <div class="footer-btm">
        <div class="l">
          <h2><img src="../assets/img/img_footer_logo.png" alt="문화셈터" /></h2>
          <div class="add-sma">
            <address>
              (30119) 세종특별자치시 갈매로 388 정부세종청사 15동<br />
              대표전화 044-203-2217&nbsp;&nbsp;
              <span>팩스: 044-203-3460</span>
            </address>
            <small>Copyright ⓒ Ministry of Culture, Sports and Tourism</small>
          </div>
        </div>
        <div class="r">
          <ul>
            <li>
              <a href="https://www.mcst.go.kr/kor/main.jsp" target="_blank">
                <img src="../assets/img/img_footer_mcst.png" alt="문화체육관광부" class="img-mcst" />
              </a>
            </li>
            <li><img src="../assets/img/img_footer_open.jpg" alt="공공누리 공공저작물 자유이용허락" class="img-open" /></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
	name: 'Footer',
	components: {
	}
}
</script>

<style>
</style>
